require('angular')
require('angular-route')
require('angular-ui-map')

require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/error-handler/error-handler-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/form/form-module')
require('../components/animate/animate-module')
require('../components/account/account-module')
require('../components/auth/auth-module')

#load Templates
require('./index.jade')

# Load Css
require('../../../sass/web/html/_group_ranking.scss')

GroupRankingCtrl = require('./group-ranking-controller')
GroupRankingService = require('./group-ranking-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-form'
  'gnp-flash'
  'gnp-animate'
  'gnp-error-handler'
]

angular.module 'gnp-app-group-ranking', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'GroupRankingCtrl', GroupRankingCtrl
  .factory 'groupRankingService', GroupRankingService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-ranking/group-ranking-module.coffee